import { z } from 'zod'

const voucherBaseSchema = z.object({
  code: z
    .string()
    .min(1, 'voucher.validation.codeRequired')
    .max(50, 'voucher.validation.codeMaxLength'),
  name: z
    .string()
    .min(1, 'voucher.validation.nameRequired')
    .max(200, 'voucher.validation.nameMaxLength'),
  discountPercent: z
    .number()
    .min(1, 'voucher.validation.discountMin')
    .max(100, 'voucher.validation.discountMax'),
  quantity: z.number().min(1, 'voucher.validation.quantityMin'),
  startDate: z.string().min(1, 'voucher.validation.startDateRequired'),
  endDate: z.string().min(1, 'voucher.validation.endDateRequired'),
  status: z.enum(['AVAILABLE', 'UNAVAILABLE']),
  type: z.enum(['POI', 'TOUR']),
  applicableTourIds: z.array(z.string()),
  applicablePoiIds: z.array(z.string()),
})

export const voucherFormSchema = voucherBaseSchema
  .refine((data) => data.endDate >= data.startDate, {
    message: 'voucher.validation.endDateAfterStartDate',
    path: ['endDate'],
  })
  .refine(
    (data) =>
      data.type === 'TOUR' ? data.applicableTourIds.length > 0 : data.applicablePoiIds.length > 0,
    { message: 'voucher.validation.applicableRequired', path: ['applicableTourIds'] },
  )

export type VoucherFormValues = z.infer<typeof voucherBaseSchema>
